









































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { mdbAlert, mdbBadge, mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbCol, mdbRow, mdbIcon, mdbTooltip } from '@folky-tools/mdbvue';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { usersService, notificationsService, deleteBusinessFrontPageHighlightService } from '@/services';

@Component({
    components: {
        mdbAlert,
        mdbBadge,
        mdbBtn,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbCol,
        mdbRow,
        mdbIcon,
        mdbTooltip
    }
})
export default class EditCustomHighlights extends Vue {
    @PropSync('businessFrontPage', { type: BusinessFrontPage }) private frontPage!: BusinessFrontPage;
    @Prop(Boolean) private pageContentLoaded!: boolean;
    private busyRemoveCustomHighlight: boolean[] = [];

    private mounted(): void {
        this.frontPage.highlights.forEach(h => {
            this.busyRemoveCustomHighlight.push(false);
        });
    }

    private async removeCustomHighlight(position: number, uniqueIdentifier: string) {
        this.busyRemoveCustomHighlight[position] = true;
        try {
            if (await deleteBusinessFrontPageHighlightService.execute(this.frontPage.businessId, uniqueIdentifier)) {
                notificationsService.showToastSuccessNotification('components.businesses.editCustomHighlights.notifications.removeCustomHighlight.success');
                this.busyRemoveCustomHighlight[position] = false;
                this.frontPage.highlights.splice(position, 1);

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.CustomHighlights,
                        entityId: +this.$route.params.id
                    })
                );
            }
        } catch {
            notificationsService.showToastErrorNotification();
        }
    }
}
